<template>
  <c360-what-is-new-modal
    :enabled="enabled"
    :content="articleBody"
    :updatedAt="updatedAt"
    @close="onClose"
  />
</template>

<script>
  import { C360WhatIsNewModal, WHAT_IS_NEW_UPDATED_AT_KEY } from '../../../components/WhatIsNew';
  import { isWhatsNewDialogAvailable, whatsNewArticle } from '../model';
  import { isDateAfter } from '../../../shared/utils/date';

  export default {
    name: 'C360WhatIsNew',

    inject: ['$c360', '$can', '$accessTokenProvider'],

    components: {
      C360WhatIsNewModal,
    },

    data() {
      return {
        enabled: false,
        articleBody: '',
        updatedAt: '',
      };
    },

    async mounted() {
      const modalUpdatedAt = this.getUpdatedAtFromStorage();

      const token = this.$accessTokenProvider();

      const { enabled, end } = await isWhatsNewDialogAvailable(this.$c360.product, token);

      if (enabled) {
        const { body, updatedAt } = await whatsNewArticle(this.$c360.product, token);
        // first time opened
        if (modalUpdatedAt === '') {
          // if now is after the end of dialog lifetime -> hide dialog
          const isAfter = isDateAfter(new Date(), new Date(end));
          this.setDialog(!isAfter, body, updatedAt);
        } else {
          const isAfter = isDateAfter(new Date(updatedAt), new Date(modalUpdatedAt));
          this.setDialog(enabled && !!body && isAfter, body, updatedAt);
        }
      }
    },

    methods: {
      onClose() {
        this.enabled = false;
      },
      getUpdatedAtFromStorage() {
        return JSON.parse(localStorage.getItem(WHAT_IS_NEW_UPDATED_AT_KEY)) || '';
      },
      setDialog(enabled, body, updatedAt) {
        this.enabled = enabled && !!body;
        this.articleBody = body;
        this.updatedAt = updatedAt;
      },
    },
  };
</script>
